import Axios from "axios";
import {
    SET_INV_ITEM_TRANSFER_LIST,
    UNSET_INV_ITEM_TRANSFER_LIST,
  } from "@/store/mutation-types";
import {saveUpdateInvItemTransfer, getInvItemTransferList, getInvItemTransferById as getInvItemTransferByIdApi } from "@/store/api";
// initial state
const state = {
  getInvItemTransferList: [],
  editingItemTransfer: null,
};

const getters = {
  getInvItemTransferList(state) {
    return state.getInvItemTransferList;
  },
  getEditingItemTransfer: (state) => { 
    return state.editingItemTransfer;
  },
};

const mutations = {
  [SET_INV_ITEM_TRANSFER_LIST](state, data) {
    state.getInvItemTransferList = data;
  },
  [UNSET_INV_ITEM_TRANSFER_LIST](state) {
    state.getInvItemTransferList = [];
  },
  setEditingItemTransfer(state, item) {
    state.editingItemTransfer = item;
  },
};

const actions = {
  saveUpdateInvItemTransfer({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateInvItemTransfer, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {

          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getInvItemTransferList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.post(getInvItemTransferList, data)
        .then(function (response) {
          commit('SET_INV_ITEM_TRANSFER_LIST', response.data.data)
          resolve(response.data.data);
        })
        .catch(function (error) {
          commit('UNSET_INV_ITEM_TRANSFER_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },

  getInvItemTransferById({ commit }, id) {
    const getInvItemTransferById = `${getInvItemTransferByIdApi}/${id}`;
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(getInvItemTransferById)
        .then((response) => {
          resolve(response.data.data);
           commit("UNSET_LOADING");
        })
        .catch((error) => {
          reject(error);
           commit("UNSET_LOADING");
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
